export const formatCurrency = (
  value: number,
  currency = 'NGN',
  locale = 'en-NG',
) => new Intl.NumberFormat(locale, {
  style: 'currency',
  currency,
  minimumFractionDigits: 2,
}).format(value);

export const getCurrencySymbol = (currency = 'NGN', locale = 'en-NG') => {
  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).formatToParts(1);
  const currencyPart = parts.find((part) => part.type === 'currency');
  return currencyPart ? currencyPart.value : '';
};

/**
 * `formatCurrency` for an amount that may be absent: a bill with no amount
 * yet renders as a dash instead of throwing inside Intl.
 */
export const formatOptionalCurrency = (
  value: number | null | undefined,
  currency = 'NGN',
  locale = 'en-NG',
) => (value === null || value === undefined ? '—' : formatCurrency(value, currency, locale));
